import SigamAPI from '~/utils/SigamAPI';

export default async function showDocument({
  documentId,
  institutionId,
  organizationUnitId,
}) {
  const response = await SigamAPI({
    url: `/SIGAM/${institutionId}/organizational-unity/${organizationUnitId}/document/${documentId}`,
    method: 'GET',
  });

  return response;
}
